import { Navigate } from "react-router";
import { useCompanyPath } from "@/hooks/useCompanyPath";

type CompanyNavigateProps = {
  to: string;
  replace?: boolean;
};

export const CompanyNavigate = ({ to, replace }: CompanyNavigateProps) => {
  const { buildPath } = useCompanyPath();
  return <Navigate to={buildPath(to)} replace={replace} />;
};
